module.exports = __webpack_public_path__ + "static/img/3.7448072.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/3.png
// module id = 87qp
// module chunks = 0